import NamePlateComponent from "@/components/dashboard/general/svgs/NamePlateComponent";
import { convertLetters } from "@/utils/letterConversion";

export default function ForgeShieldTwoSelectionPage() {
    const title = convertLetters("Forge Your Second Shield");
    const subtitleText = convertLetters(
        "Select a shield design to commemorate your 12 months in the Gift of the Aesir!",
    );

    return (
        <>
            <div className="mt-5 grid grid-cols-4 gap-20 p-20">
                {/* Align vertically and horizontally center */}
                <div className="col-span-4 flex items-center justify-center justify-items-center pt-10">
                    <h1
                        className="font-prviking border-text text-brand text-center text-9xl"
                        dangerouslySetInnerHTML={{ __html: title }}
                    />
                </div>
                <div className="col-span-4 flex items-center justify-center justify-items-center">
                    <h2 className="font-prviking border-text text-brand text-center text-7xl">
                        <span
                            dangerouslySetInnerHTML={{ __html: subtitleText }}
                        />
                    </h2>
                </div>

                <div className="col-span-4 lg:col-span-2 xl:col-span-1">
                    <div className="flex items-center justify-center">
                        <div className="relative">
                            <a href="/forge-shield-two/shields/berserkir">
                                <img
                                    src="/shields/BERSERKIR.svg"
                                    alt="Berserkir Shield"
                                    className="border-brand h-80 w-80 rounded-lg border-8 p-4"
                                    style={{
                                        backgroundImage:
                                            "url(/wallhalla-blank-wall.png)",
                                    }}
                                />
                                <NamePlateComponent
                                    text="Berserkir"
                                    className="absolute bottom-[-15px] left-1/2 z-10 -translate-x-1/2 transform"
                                />
                            </a>
                        </div>
                    </div>
                </div>
                <div className="col-span-4 lg:col-span-2 xl:col-span-1">
                    <div className="flex items-center justify-center">
                        <div className="relative">
                            <a href="/forge-shield-two/shields/midgard">
                                <img
                                    src="/shields/MIDGARD.svg"
                                    alt="Midgard Shield"
                                    className="border-brand h-80 w-80 rounded-lg border-8 p-4"
                                    style={{
                                        backgroundImage:
                                            "url(/wallhalla-blank-wall.png)",
                                    }}
                                />
                                <NamePlateComponent
                                    text="Midgard"
                                    className="absolute bottom-[-15px] left-1/2 z-10 -translate-x-1/2 transform"
                                />
                            </a>
                        </div>
                    </div>
                </div>
                <div className="col-span-4 lg:col-span-2 xl:col-span-1">
                    <div className="flex items-center justify-center">
                        <div className="relative">
                            <a href="/forge-shield-two/shields/kross">
                                <img
                                    src="/shields/KROSS.svg"
                                    alt="Kross Shield"
                                    className="border-brand h-80 w-80 rounded-lg border-8 p-4"
                                    style={{
                                        backgroundImage:
                                            "url(/wallhalla-blank-wall.png)",
                                    }}
                                />
                                <NamePlateComponent
                                    text="Kross"
                                    className="absolute bottom-[-15px] left-1/2 z-10 -translate-x-1/2 transform"
                                />
                            </a>
                        </div>
                    </div>
                </div>
                {/* ISAZ */}
                <div className="col-span-4 lg:col-span-2 xl:col-span-1">
                    <div className="flex items-center justify-center">
                        <div className="relative">
                            <a href="/forge-shield-two/shields/isaz">
                                <img
                                    src="/shields/ISAZ.svg"
                                    alt="Isaz Shield"
                                    className="border-brand h-80 w-80 rounded-lg border-8 p-4"
                                    style={{
                                        backgroundImage:
                                            "url(/wallhalla-blank-wall.png)",
                                    }}
                                />
                                <NamePlateComponent
                                    text="Isaz"
                                    className="absolute bottom-[-15px] left-1/2 z-10 -translate-x-1/2 transform"
                                />
                            </a>
                        </div>
                    </div>
                </div>
                {/* GEBO */}
                <div className="col-span-4 lg:col-span-2 xl:col-span-1">
                    <div className="flex items-center justify-center">
                        <div className="relative">
                            <a href="/forge-shield-two/shields/gebo">
                                <img
                                    src="/shields/GEBO.svg"
                                    alt="Gebo Shield"
                                    className="border-brand h-80 w-80 rounded-lg border-8 p-4"
                                    style={{
                                        backgroundImage:
                                            "url(/wallhalla-blank-wall.png)",
                                    }}
                                />
                                <NamePlateComponent
                                    text="Gebo"
                                    className="absolute bottom-[-15px] left-1/2 z-10 -translate-x-1/2 transform"
                                />
                            </a>
                        </div>
                    </div>
                </div>
                {/* NORBAUSTA */}
                <div className="col-span-4 lg:col-span-2 xl:col-span-1">
                    <div className="flex items-center justify-center">
                        <div className="relative">
                            <a href="/forge-shield-two/shields/norbausta">
                                <img
                                    src="/shields/NORBAUSTA.svg"
                                    alt="Norbausta Shield"
                                    className="border-brand h-80 w-80 rounded-lg border-8 p-4"
                                    style={{
                                        backgroundImage:
                                            "url(/wallhalla-blank-wall.png)",
                                    }}
                                />
                                <NamePlateComponent
                                    text="Norbausta"
                                    className="absolute bottom-[-15px] left-1/2 z-10 -translate-x-1/2 transform"
                                />
                            </a>
                        </div>
                    </div>
                </div>
                {/* STJARNA */}
                <div className="col-span-4 lg:col-span-2 xl:col-span-1">
                    <div className="flex items-center justify-center">
                        <div className="relative">
                            <a href="/forge-shield-two/shields/stjarna">
                                <img
                                    src="/shields/STJARNA.svg"
                                    alt="Stjarna Shield"
                                    className="border-brand h-80 w-80 rounded-lg border-8 p-4"
                                    style={{
                                        backgroundImage:
                                            "url(/wallhalla-blank-wall.png)",
                                    }}
                                />
                                <NamePlateComponent
                                    text="Stjarna"
                                    className="absolute bottom-[-15px] left-1/2 z-10 -translate-x-1/2 transform"
                                />
                            </a>
                        </div>
                    </div>
                </div>
                {/* NORBVESTUR */}
                <div className="col-span-4 lg:col-span-2 xl:col-span-1">
                    <div className="flex items-center justify-center">
                        <div className="relative">
                            <a href="/forge-shield-two/shields/norbvestur">
                                <img
                                    src="/shields/NORBVESTUR.svg"
                                    alt="Norbvestur Shield"
                                    className="border-brand h-80 w-80 rounded-lg border-8 p-4"
                                    style={{
                                        backgroundImage:
                                            "url(/wallhalla-blank-wall.png)",
                                    }}
                                />
                                <NamePlateComponent
                                    text="Norbvestur"
                                    className="absolute bottom-[-15px] left-1/2 z-10 -translate-x-1/2 transform"
                                />
                            </a>
                        </div>
                    </div>
                </div>
                {/* URUZ */}
                <div className="col-span-4 lg:col-span-2 xl:col-span-1 xl:col-start-2">
                    <div className="flex items-center justify-center">
                        <div className="relative">
                            <a href="/forge-shield-two/shields/uruz">
                                <img
                                    src="/shields/URUZ.svg"
                                    alt="Uruz Shield"
                                    className="border-brand h-80 w-80 rounded-lg border-8 p-4"
                                    style={{
                                        backgroundImage:
                                            "url(/wallhalla-blank-wall.png)",
                                    }}
                                />
                                <NamePlateComponent
                                    text="Uruz"
                                    className="absolute bottom-[-15px] left-1/2 z-10 -translate-x-1/2 transform"
                                />
                            </a>
                        </div>
                    </div>
                </div>
                {/* ZURU */}
                <div className="col-span-4 lg:col-span-2 xl:col-span-1">
                    <div className="flex items-center justify-center">
                        <div className="relative">
                            <a href="/forge-shield-two/shields/zuru">
                                <img
                                    src="/shields/ZURU.svg"
                                    alt="Zuru Shield"
                                    className="border-brand h-80 w-80 rounded-lg border-8 p-4"
                                    style={{
                                        backgroundImage:
                                            "url(/wallhalla-blank-wall.png)",
                                    }}
                                />
                                <NamePlateComponent
                                    text="Zuru"
                                    className="absolute bottom-[-15px] left-1/2 z-10 -translate-x-1/2 transform"
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
